/**
 * @file Saga creating a company (`POST company`, answering `{data: {company, subscription}}`) from the contacts page or a lookup.
 * A refused create runs ErrorHandlerSequence and the matching `*_CREATE_FAILURE`.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import CompanyFactory from "../../Entity/Factories/CompanyFactory";
import SubscriptionFactory from "../../Entity/Factories/SubscriptionFactory";
import { SubscriptionInterface } from "../../Entity/Entities/Subscription/SubscriptionInterface";
import { ActionInterface } from "../../Interface/ActionInterface";
import { CompanyInterface } from "../../Entity/Entities/Company/CompanyInterface";

export default function* companyCreate(action: ActionInterface): any {
  switch (action.type) {
    case Constants.PAGE_CONTACT_COMPANY_CREATE_START:
      try {
        yield put({
          type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
        });

        yield put({
          type: Constants.PAGE_CONTACT_COMPANY_CREATE_REQUEST
        });

        const res = yield call(Http.post, "company", action.payload?.company);
        const company: CompanyInterface = CompanyFactory.create(res.data.data.company);
        const subscription: SubscriptionInterface = SubscriptionFactory.create(res.data.data.subscription);

        yield put({
          type: Constants.PAGE_CONTACT_COMPANY_CREATE_SUCCESS,
          payload: {
            company: company
          }
        });

        yield put({
          type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
          payload: {
            subscription: subscription
          }
        });

        if (!action.payload?.hideSnackbar) {
          yield put({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: Translator.trans(`snackbar-message-${action.payload?.company.pageTemplate}-created-successfully`),
              type: "success"
            }
          });
        }

        yield put({
          type: Constants.PAGE_CONTACTS_SWITCH_TAB,
          payload: {
            index: 1
          }
        });

        if (action.hasOwnProperty("onSuccess") === true) {
          action.onSuccess.call(this, company);
        }
      } catch (err) {
        yield ErrorHandlerSequence(err, action);

        yield put({
          type: Constants.PAGE_CONTACT_COMPANY_CREATE_FAILURE,
          payload: {
            err: err
          }
        });
      }
      break;

    case Constants.LOOKUP_COMPONENT_COMPANY_CREATE_START:
      try {
        yield put({
          type: Constants.LOOKUP_COMPONENT_COMPANY_CREATE_REQUEST
        });

        const res = yield call(Http.post, "company", action.payload?.company);
        const subscription: SubscriptionInterface = SubscriptionFactory.create(res.data.data.subscription);

        yield put({
          type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
          payload: {
            subscription: subscription
          }
        });

        yield put({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: Translator.trans(`snackbar-message-${action.payload?.company.pageTemplate}-created-successfully`),
            type: "success"
          }
        });

      } catch (err) {
        yield ErrorHandlerSequence(err, action);

        yield put({
          type: Constants.LOOKUP_COMPONENT_COMPANY_CREATE_FAILURE,
          payload: {
            err: err
          }
        });
      }
      break;

   default:
     return;
  }
}

export function* watchCompanyCreate() {
  yield takeEvery(Constants.PAGE_CONTACT_COMPANY_CREATE_START, companyCreate);
  yield takeEvery(Constants.LOOKUP_COMPONENT_COMPANY_CREATE_START, companyCreate);
}
